import React from "react";
import "react-activity/dist/Dots.css";
import { UserHelper } from "../helpers";

interface Props { }

export const AccountWarnings: React.FC<Props> = (props) => {
  let result = <></>
  switch (UserHelper.currentDepartment?.accountStatus?.toLowerCase())
  {
    case "probation":
      result = (<div className="alert alert-danger" role="alert"><i className="fa fa-exclamation-triangle"></i> Payment failed.  Service will deactivate soon.  Please update your billing info by clicking on Account Name -&gt; Settings.</div>)
      break;
    case "suspended":
      result = (<div className="alert alert-danger" role="alert"><i className="fa fa-exclamation-triangle"></i> Payment failed.  Account is suspended.  Please update your billing info by clicking on Account Name -&gt; Settings.</div>)
      break;
  }

  return result;
}